import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { requestHandler } from '../utils/requestHandler';
import { TNC_ENDPOINT } from '../utils/constants/controlCenterConstants';
import { isMock, setErrorInAppState } from '../utils/helpers';
import { termsAndConditionsResponse } from '../mocks/mockTermsAndConditionsResponse';
import {
  AppState,
  TermsAndConditionsSlice,
} from '../interfaces/store.interface';

const defaultContent = {
  EN: {},
};

export const initialState: TermsAndConditionsSlice = {
  data: defaultContent,
  allLanguageData: {},
  errorLoadingContent: false,
  loadApp: false,
  lang: 'EN',
};

export const termsAndConditions = 'termsAndConditions';

export const fetchClientTermsAndConditions = createAsyncThunk(
  `${termsAndConditions}/fetchClientTermsAndConditions`,
  async () => {
    try {
      if (isMock()) {
        return termsAndConditionsResponse.data;
      } else {
        const { data }: any = await requestHandler({
          customHeaders: {
            'Content-Type': 'application/json',
          },
          skipAuthToken: true,
        }).get(TNC_ENDPOINT);
        return data;
      }
    } catch (error: any) {
      const errorObject = error?.response || error;
      setErrorInAppState(errorObject, 'tnc');
      return error;
    }
  },
);

export const termsAndConditionsSlice = createSlice({
  name: termsAndConditions,
  initialState,
  reducers: {
    setLanguageForTnc: (state: any, action) => {
      state.lang = action.payload;
      state.data = state.allLanguageData[state.lang];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchClientTermsAndConditions.fulfilled,
      (state: any, { payload }: any) => {
        state.loadApp = true;
        state.errorLoadingContent = false;
        state.allLanguageData = payload;
        state.data = payload[state.lang];
      },
    );
    builder.addCase(fetchClientTermsAndConditions.rejected, (state: any) => {
      state.loadApp = true; // this can be flipped to false to show error page
      state.errorLoadingContent = true;
    });
  },
});
// state actions can be exported here

export const { setLanguageForTnc } = termsAndConditionsSlice.actions;
export default termsAndConditionsSlice.reducer;

export const getClientTermsAndConditions = (state: AppState) =>
  state.termsAndConditions?.data;
